import React from "react";
import { Link } from "react-router-dom";
import './styles.css'

// ---------------------------------------------------
// ---------------------------------------------------

export default function Pop_msg(props){

    const {titulo, subtitulo, btn_to, btn_txt} = props;

    return (
        <div name="ok" className="parabens">
            <div className="conteiner parabens-corpo">
                <h1 className="text-n1 archivo-bold-color-text-54px">{titulo}</h1>
                <p className="text-n2 poppins-normal-color-text-16px">{subtitulo}</p>
                <Link to={btn_to} className="boto djbtn dj-align-text-middle">
                    <div className="btn-txt archivo-semi-bold-white-18px">{btn_txt}</div>
                </Link>
            </div>
        </div>
    )
}
